import { ActionDispatching, UserInfo } from 'app/types-shared';
import { ReceiveUserInfo, UserLocaleChange } from 'app/shell/action-types';
import { errorSafe } from 'app/infrastructure/redux';
import { ApplicationState } from 'app/types-store';
import { api } from './api';
import { actionCreators as remoteDataActionCreators } from 'app/infrastructure/remote-data/actions';
import { globalVar } from 'app/infrastructure/universal';

export const actionCreators = {
  setActiveAnonCtx: (incomingAnonCtx: string): ActionDispatching<any, any> => async (dispatch: any) => {
    const storage = globalVar('sessionStorage') as Storage;
    let anonCtx = incomingAnonCtx;
    if (!anonCtx) {
      anonCtx = storage.getItem('anonCtx');
    }
    anonCtx && storage.setItem('anonCtx', anonCtx);
    anonCtx && dispatch(remoteDataActionCreators.addQueryParam('anonCtx', anonCtx));
    dispatch(actionCreators.getContextDetails());
  },

  getContextDetails: (): ActionDispatching<any, any> => async (dispatch: any) => {
    try {
      const contextDetails = await api.getContextDetails();
      const anonymousUserInfo: UserInfo = {
        language: contextDetails.language,
        unit: {},
        location: {},
        userGroup: {}
      } as any;
      dispatch(new ReceiveUserInfo(anonymousUserInfo));
    }
    catch (e) {
      if (e && e.response && e.response.status === 400) {
        // Clear the context and reload the tab without query params
        const storage = globalVar('sessionStorage') as Storage;
        storage.removeItem('anonCtx');
        window.location.search = '';
      }
    }
  },

  changeUserLocale: (
    locale: string
  ): ActionDispatching<any, ApplicationState> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(new UserLocaleChange(locale));
    })
};
